import * as colors from 'constants/colors'
import styled from 'styled-components'
import IButton from './props'

export const ComponentButton = styled.button<IButton>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3em;
  padding: 10px;
  background-color: ${({ outline, disabled }) => (
    disabled ? '#656565' : 
      outline ? 'transparent' : colors.primary01
  )};
  border: 1px solid ${({ disabled }) => disabled ? '#656565' : colors.primary01};
  border-radius: ${({ round }) => round ? '50%' : '4px'};
  color: ${({ outline, disabled }) => (
    disabled ? '#cfcfcf' :
      outline ? colors.primary01 : colors.neutral02
  )};
  font-weight: 500;
  width: ${({ round }) => round ? `48px` : '100%'};
  height: 40px;
  cursor: ${({ loading, disabled }) =>
  disabled ? 'not-allowed' :
    loading ? 'auto' : 'pointer'
};
  text-transform: ${({ upperCase }) => (upperCase ? 'uppercase' : 'none')};

  &:hover{
    opacity: 0.8;
  }
`
